import { CoinIcon, GiftIcon, FlashIcon, TrophyStarIcon } from '@repo/ui'
import type {
  InventoryNotificationItem,
  RewardNotificationItem,
  AchievementNotificationItem,
  SystemNotificationItem,
  CustomNotificationItem,
  LevelUpNotificationItem,
  NotificationAccentColor
} from '../types/domain'
import { type HandlerMap } from '../utils/rewardTagHandlers'

const REWARD_ICON_STYLES = 'w-[14px] h-[14px] drop-shadow-[0_0_2px_rgba(0,0,0,0.25)]'

export const rewardTagByType: HandlerMap = {
  inventory: (item: InventoryNotificationItem, onClose: () => void) => ({
    accentColor: (item.accentColor || 'blue') as NotificationAccentColor,
    icon: item.data.tagIcon,
    label: item.data.tagLabel,
    reward: item.data.reward,
    cta: item.cta
      ? {
          icon: (
            <span className="text-[12px] font-bold text-white drop-shadow-[0_0_2px_rgba(0,0,0,0.25)] transition-transform duration-300 group-hover:scale-105">
              {item.cta.label}
            </span>
          ),
          onClick: () => {
            item.cta?.onClick(onClose)
          },
          className: 'group'
        }
      : undefined
  }),

  reward: (item: RewardNotificationItem, _onClose: () => void) => ({
    accentColor: (item.accentColor || 'yellow') as NotificationAccentColor,
    icon: <CoinIcon className={REWARD_ICON_STYLES} />,
    label: item.data.currency || 'Reward',
    reward: item.data.amount
  }),

  achievement: (item: AchievementNotificationItem, _onClose: () => void) => ({
    accentColor: (item.accentColor || 'green') as NotificationAccentColor,
    icon: <GiftIcon className={REWARD_ICON_STYLES} />,
    label: 'Achievement',
    reward: `+${item.data.points || 0}`
  }),

  system: (_item: SystemNotificationItem, _onClose: () => void) => ({
    accentColor: 'blue',
    icon: <FlashIcon className={REWARD_ICON_STYLES} />,
    label: 'System',
    reward: ''
  }),

  custom: (_item: CustomNotificationItem, _onClose: () => void) => ({
    accentColor: 'blue',
    icon: <FlashIcon className={REWARD_ICON_STYLES} />,
    label: 'Notification',
    reward: ''
  }),

  levelup: (item: LevelUpNotificationItem, _onClose: () => void) => ({
    accentColor: (item.accentColor || 'yellow') as NotificationAccentColor,
    icon: <TrophyStarIcon className={REWARD_ICON_STYLES} />,
    label: `Level ${item.data.newLevel}`,
    reward: `+${item.data.multiplierBonus}%`
  })
}
